import { Info, ReferenceObjectData } from '../utils/UNSAFE_visTypes/chart';
import { Group, Scale } from '../utils/UNSAFE_visTypes/chart';
import { ReferenceLineArea } from './ReferenceLineArea';

// Main renderer component
export function ReferenceObjects({
  location,
  xAxis,
  yAxis,
  y2Axis,
  xScale,
  yScale,
  y2Scale,
  orientation,
  xAxisInfo,
  groups,
  activeId,
  activeInfo
}: {
  location: 'front' | 'back';
  xAxis?: { referenceObjects?: ReferenceObjectData[] };
  yAxis?: { referenceObjects?: ReferenceObjectData[] };
  y2Axis?: { referenceObjects?: ReferenceObjectData[] };
  xScale: Scale;
  yScale: Scale;
  y2Scale: Scale;
  orientation: string;
  xAxisInfo: { startIndex: number; endIndex: number };
  groups: Group[];
  activeId?: string;
  activeInfo?: Info;
}) {
  const filterFunc = (item: ReferenceObjectData) =>
    location === 'front' ? item.location === 'front' : item.location !== 'front';

  return (
    <>
      {xAxis?.referenceObjects
        ?.filter(filterFunc)
        .map((item, index) => (
          <ReferenceLineArea
            {...item}
            key={item.id}
            xScale={xScale}
            yScale={yScale}
            orientation={orientation as 'horizontal' | 'vertical'}
            groups={groups}
            xStartIndex={xAxisInfo.startIndex}
            xEndIndex={xAxisInfo.endIndex}
            seriesIndex={index}
            isXRef={true}
            activeId={item.id === activeInfo?.refObjId ? activeId : undefined}
          />
        ))}

      {yAxis?.referenceObjects
        ?.filter(filterFunc)
        .map((item, index) => (
          <ReferenceLineArea
            {...item}
            xScale={xScale}
            yScale={yScale}
            orientation={orientation as 'horizontal' | 'vertical'}
            groups={groups}
            xStartIndex={xAxisInfo.startIndex}
            xEndIndex={xAxisInfo.endIndex}
            seriesIndex={index}
            activeId={item.id === activeInfo?.refObjId ? activeId : undefined}
          />
        ))}

      {y2Axis?.referenceObjects
        ?.filter(filterFunc)
        .map((item, index) => (
          <ReferenceLineArea
            {...item}
            xScale={xScale}
            yScale={y2Scale}
            orientation={orientation as 'horizontal' | 'vertical'}
            groups={groups}
            xStartIndex={xAxisInfo.startIndex}
            xEndIndex={xAxisInfo.endIndex}
            seriesIndex={index}
            activeId={item.id === activeInfo?.refObjId ? activeId : undefined}
          />
        ))}
    </>
  );
}
